import React from "react";
import {
  Route,
  RouteComponentProps,
  Switch,
  useHistory
} from "react-router-dom";
import {
  getBenefitsEnrollInsuranceFlowPathname,
  PATH_BENEFITS_INSURANCE
} from "../../paths";
import { EnrollOAI } from "./OAI";
import { EnrollPGLI } from "./PGLI";
import { OAI_KEY, PGLI_KEY } from "../../utils/constants";
import { useHistoryCheckpoint } from "../../../../shared/hooks/useHistoryCheckpoint";
import { ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT } from "../../../Requirements/modules/InsuranceCoverage/components/CardWingspanInsurance";

export const RouteEnrollInsurance: React.FC<
  RouteComponentProps<
    {},
    any,
    {
      backPath?: string;
    }
  >
> = props => {
  const history = useHistory();

  const historyCheckpoint = useHistoryCheckpoint(
    ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT
  );

  const goBack = () => {
    const backPath = props.location.state?.backPath || PATH_BENEFITS_INSURANCE;

    if (historyCheckpoint.isCheckpointSaved()) {
      historyCheckpoint.goToCheckpoint();
    } else {
      history.push(backPath);
    }
  };

  return (
    <Switch>
      <Route
        render={({ match }) => {
          return <EnrollOAI basePath={match.path} goBack={goBack} />;
        }}
        path={getBenefitsEnrollInsuranceFlowPathname(OAI_KEY)}
      />
      <Route
        render={({ match }) => {
          return <EnrollPGLI basePath={match.path} goBack={goBack} />;
        }}
        path={getBenefitsEnrollInsuranceFlowPathname(PGLI_KEY)}
      />
    </Switch>
  );
};
